<template>
  <v-alert
    :model-value="modelValue"
    :color="color"
    class="notice-alert text-body-2 text-md-center"
    closable
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <span class="d-inline-flex">
      <PhInfo class="text-h5 text-sm-h6 flex-shrink-0 mr-2" :class="iconColor" weight="fill" />
      <span>
        <slot />
      </span>
    </span>
    <template #close>
      <BrandButton
        size="small"
        icon
        :aria-label="$t('cta.close')"
        @click="$emit('update:modelValue', false)"
      >
        <PhX class="text-h6" />
      </BrandButton>
    </template>
  </v-alert>
</template>

<script setup>
import { PhInfo, PhX } from '@phosphor-icons/vue'
import BrandButton from '@/components/global/brand/BrandButton.vue'

// App-level notice strip shown above the page content: an info icon, a line of
// text with an inline call-to-action, and a close button.
defineProps({
  modelValue: {
    type: Boolean,
    default: true,
  },
  // v-alert color, e.g. 'orange25 text-orange900'
  color: {
    type: String,
    required: true,
  },
  // text colour class for the icon, e.g. 'text-orange400'
  iconColor: {
    type: String,
    default: null,
  },
})

defineEmits(['update:modelValue'])
</script>

<style lang="scss" scoped>
.notice-alert :deep(.v-alert__wrapper) {
  align-items: center;
}
</style>
